import React from 'react';

const Welcome = () => {
    return(
        <div>
            <h1 style={{ fontSize: 60, textAlign: "center" }}>
                Welcome to ExamPortal!
            </h1>
        </div>
    );
}

export default Welcome;